import { jwtDecode } from "jwt-decode";

export function applySessionToken(token, navigate) {
  const { role, companies, branches } = jwtDecode(token);
  localStorage.setItem("token", token);

  if (role === "super admin" || role === "root user") {
    navigate("/", { replace: true });
    return;
  }

  if (role === "admin") {
    const firstScopeId = branches?.[0] || companies?.[0];
    navigate("/dashboard", {
      replace: true,
      state: { companyId: firstScopeId, branchId: branches?.[0] },
    });
    return;
  }

  if (role === "nutriology") {
    navigate("/nutrilogyPanel", { replace: true });
    return;
  }

  navigate("/unauthorized", { replace: true });
}
